<template>
<div>
  <div id="top">
    <nav-bar-simple />
  </div>
  <div>
    <b-container>
      <b-card no-body class="overflow-hidden mx-auto" style="max-width: 720px; margin-top: 150px;">
        <b-card-img :src="require('@/assets/HRS_Virtual_Training_Logo.png')" class="p-5"></b-card-img>
        <b-row no-gutters>
          <b-col style="text-align: left;">
            <h3 style="margin: 25px 15px;">Training Portal Login</h3>
            <b-form v-on:submit.prevent="onSubmit" class="m-3">
              <b-form-group
                id="input-group-1"
                label="Email:"
                label-for="input-1"
              >
                <b-form-input id="input-1" v-model="email" type="email" required placeholder="Email"></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-2" label="Password:" label-for="input-2">
                <b-form-input
                  id="input-2"
                  type="password"
                  v-model="password"
                  required
                  placeholder="Password"
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mr-2" :disabled="loggingIn">Login</b-button>
              <b-button type="button" variant="link" :to="{ name: 'ForgotPassword' }">Forgot Password?</b-button>
              <img
                v-show="loggingIn"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              >
            </b-form>
          </b-col>
        </b-row>
        <b-card-footer>
          <b-button :to="{ name: 'Help' }" variant="link">Need more help?</b-button>
        </b-card-footer>
      </b-card>
      <b-alert variant="danger" v-model="hasError" style="max-width: 720px; margin: 25px auto;">
        {{error}}
      </b-alert>
    </b-container>
  </div>
</div>
</template>

<script>
import NavBarSimple from '@/views/layouts/components/NavBarSimple'

export default {
  name: 'LoginPage',
  data () {
    return {
      email: '',
      password: '',
      submitted: false,
      error: null,
      hasError: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.auth.status.loggingIn
    }
  },
  created () {},
  methods: {
    // eslint-disable-next-line
    onSubmit (e) {
      var vm = this
      vm.submitted = true
      vm.error = null
      vm.hasError = false
      const { email, password } = this
      const { dispatch } = this.$store

      if (email && password) {
        dispatch('auth/login', { email, password })
          .then(() => {
            if (vm.$store.state.auth.currentUser.roles.includes('Administrator')) {
              vm.$router.push({ name: 'Admin' })
            } else {
              vm.$router.push('/')
            }
          })
          .catch((e) => {
            console.log(e)
            vm.error = 'Login Failed.'
            vm.hasError = true
          })
      }
    }
  },
  components: {
    NavBarSimple
  }
}
</script>
